import $ from "jquery";

/******************************************/
/*************** PUBLICATIONS *************/
/******************************************/
$(function() {
    var $publications = $('#container_loadResult_js');    
    var $seeMore = $("#load_more_js");    
    var $filterCategories = $('#filter_category_js');
    var $filterTag = $('#filter_tag_js');
    var $filterType = $('#filter_type_js');
    var $filterTerritory = $('#filter_territory_js');
    
    var page = 1;
    let loadPublications = function(reset){
        if(reset === true)
            page = 1;
        $publications.addClass('loading');        
        var data = {
            'action': 'load_publications',
            'page': page,
            'lang' : _lang
        };
        
        //categories
        if($filterCategories.find('input[type=checkbox]:checked')){
            data.categories = [];
            $filterCategories.find('input[type=checkbox]:checked').each(function(){
                data.categories.push($(this).val());                
            });
        }

        // mots clés
        if($filterTag.find('select').val() !== 0){
            data.tag = $filterTag.find('select').val();
        }
        // type
        if($filterType.find('select').val() !== 0){
            data.type = $filterType.find('select').val();
        }
        // territoire
        if($filterTerritory.find('select').val() !== 0){
            data.territory = $filterTerritory.find('select').val();
        }
        $.post(ajaxurl, data, function(response) {     
            if(reset === true){
                $seeMore.prevAll().remove();
            }          
            $(response.publications).insertBefore($seeMore);
            $seeMore.toggle(response.more);
            $publications.removeClass('loading');
        });
    }    
    // ----- infinite scroll    
    $seeMore.click(function(e){
        e.preventDefault();
        page++;
        loadPublications(false);        
    });     
    // ----- filtre catégorie
    $filterCategories.find('input[type=checkbox]').change(function(){
        loadPublications(true);
    });
    // ------ filtres mots clés
    $filterTag.find('select').change(function(){
        loadPublications(true);
    });
    // filtres type
    $filterType.find('select').change(function(){
        loadPublications(true);
    });
    // filtres type
    $filterTerritory.find('select').change(function(){
        loadPublications(true);
    });
    //--- chargement de la page
    if($publications.length > 0)
        loadPublications(false);
});